/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TABS_DIRECTIVES } from "./index";
var ClrTabsModule = (function () {
    function ClrTabsModule() {
    }
    return ClrTabsModule;
}());
export { ClrTabsModule };
ClrTabsModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    TABS_DIRECTIVES
                ],
                exports: [
                    TABS_DIRECTIVES
                ]
            },] },
];
/** @nocollapse */
ClrTabsModule.ctorParameters = function () { return []; };
//# sourceMappingURL=tabs.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/layout/tabs/tabs.module.js
// module id = 195
// module chunks = 4